// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23 21H1V3H23V21ZM6.5 8C5.82175 8 5 8.50067 5 9.42871V14.5713C5 15.4993 5.82175 16 6.5 16H11V14H7V13H11V11H7V10H11V8H6.5ZM13 8V16H15V10H17V16H19V9.42871C19 8.6058 18.3188 8.00006 17.5557 8H13Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-english-rectangle-filled')
export default class EnglishRectangleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'english-rectangle-filled',
    }
  }
}
